import { uuid4 } from '@sentry/utils';
import { UIEventEmitter } from '../UIEventEmitter.ts';
import { DiscordCommand, DiscordCustomEvent } from '../../../../shared/DiscordActivityTypes.ts';
import { DiscordPopupFromMountHandler } from './DiscordPopupFromMountHandler.ts';
export class DiscordContentFrameCommunicationHandler {
    static normalizeOptionalString(value) {
        if (value == null) return undefined;
        if (value == 'undefined') return undefined;
        return value;
    }
    async waitToBeReady() {
        return this.readyPromise;
    }
    async subscribeToDiscordEvent(event, callback) {
        const listenerCount = this.subscriptionListener.listenerCount(event);
        const firstTimeSubscribing = listenerCount == 0;
        if (firstTimeSubscribing) {
            await this.sendMessageToMount({
                command: DiscordCommand.Subscribe,
                subscription: event
            });
        }
        const listener = this.subscriptionListener.subscribe(event, callback);
        return listener;
    }
    async unsubscribeFromDiscordEvent(event, callback) {
        const listenerCount = this.subscriptionListener.listenerCount(event);
        const onlyOneListenerLeft = listenerCount == 1;
        if (onlyOneListenerLeft) {
            await this.sendMessageToMount({
                command: DiscordCommand.Unsubscribe,
                event: event
            });
        }
        this.subscriptionListener.unsubscribe(event, callback);
    }
    handleMessageReceivedFromMount({ data: messageData, origin }) {
        var // Resolve the promise that was waiting for a response from the mount
        _this_messagesWaitingForResponse_get;
        if (typeof messageData !== 'object' || Array.isArray(messageData) || messageData === null) return;
        try {
            const referrerOrigin = new URL(document.referrer).origin;
            if (origin !== referrerOrigin) return;
        } catch (e) {
            return;
        }
        const { messageId, event, command, data, args } = messageData;
        if (event === DiscordCustomEvent.CreateMountPopup) {
            this.mountPopupHandler.createPopup(data);
            return;
        }
        if (command === DiscordCommand.DispatchDiscordEvent) {
            if (event == null) throw new Error('Event is missing');
            this.subscriptionListener.emit(event, data);
        }
        if (messageId == undefined) return;
        (_this_messagesWaitingForResponse_get = this.messagesWaitingForResponse.get(messageId)) === null || _this_messagesWaitingForResponse_get === void 0 ? void 0 : _this_messagesWaitingForResponse_get.resolve(data);
        this.messagesWaitingForResponse.delete(messageId);
    }
    sendMessageToMount(messageData) {
        // eslint-disable-next-line no-console
        console.log('Sending message', messageData);
        const messageId = uuid4();
        window.parent.postMessage({
            messageId: messageId,
            ...messageData
        }, document.referrer ? document.referrer : '*');
        const waitUntilMountRespondsPromise = new Promise((resolve, reject)=>{
            this.messagesWaitingForResponse.set(messageId, {
                resolve: resolve,
                reject: reject
            });
        });
        return waitUntilMountRespondsPromise;
    }
    openExternalLink(url) {
        void this.sendMessageToMount({
            command: DiscordCommand.OpenExternalLink,
            data: {
                url: url
            }
        });
    }
    constructor(){
        this.messagesWaitingForResponse = new Map();
        this.subscriptionListener = new UIEventEmitter();
        window.addEventListener('message', (data)=>this.handleMessageReceivedFromMount(data));
        this.mountPopupHandler = new DiscordPopupFromMountHandler(this);
        this.readyPromise = new Promise((resolve)=>{
            this.subscriptionListener.subscribeOnce(DiscordCustomEvent.Ready, ({ instanceId, serverId, userDiscordAccessToken, serverProfile, userPermissions, referrerId, referralTypeId, isInitialLoad })=>{
                this.voiceChannelId = instanceId;
                this.inDiscordServer = serverId != null;
                this.userDiscordAccessToken = userDiscordAccessToken;
                this.serverProfile = serverProfile;
                this.userPermissions = userPermissions;
                this.referrerId = DiscordContentFrameCommunicationHandler.normalizeOptionalString(referrerId);
                this.referralTypeId = DiscordContentFrameCommunicationHandler.normalizeOptionalString(referralTypeId);
                this.isInitialLoad = isInitialLoad;
                resolve();
            });
        });
        void this.sendMessageToMount({
            command: DiscordCommand.ContentFrameReady
        });
    }
}
